// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-13d3ddad9198/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-13d3ddad9198/bin/redo/bigcommerce-storefront/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._p-0 {\n  display: flex;\n}\n\n._p-1 {\n  flex-direction: row;\n}\n\n._p-1._p-2 {\n    flex-direction: row-reverse;\n  }\n._p-3 {\n  flex-direction: column;\n}\n._p-3._p-2 {\n    flex-direction: column-reverse;\n  }\n\n._p-4 {\n  align-items: center;\n}\n._p-5 {\n  align-items: flex-start;\n}\n._p-6 {\n  align-items: flex-end;\n}\n._p-7 {\n  align-items: stretch;\n}\n._p-8 {\n  align-items: baseline;\n}\n\n._p-9 {\n  align-self: center;\n}\n._p-a {\n  align-self: flex-start;\n}\n._p-b {\n  align-self: flex-end;\n}\n._p-c {\n  align-self: stretch;\n}\n._p-d {\n  align-self: baseline;\n}\n\n._p-e {\n  justify-content: center;\n}\n._p-f {\n  justify-content: flex-start;\n}\n._p-g {\n  justify-content: flex-end;\n}\n._p-h {\n  justify-content: space-between;\n}\n._p-i {\n  justify-content: space-around;\n}\n._p-j {\n  justify-content: space-evenly;\n}\n\n._p-k {\n  flex-wrap: wrap;\n}\n\n._p-l {\n  flex-wrap: nowrap;\n}\n\n._p-m {\n  flex-wrap: wrap-reverse;\n}\n", ""]);
// Exports
export var flex = "_p-0";
export var row = "_p-1";
export var reverse = "_p-2";
export var column = "_p-3";
export var alignCenter = "_p-4";
export var alignFlexStart = "_p-5";
export var alignFlexEnd = "_p-6";
export var alignStretch = "_p-7";
export var alignBaseline = "_p-8";
export var alignSelfCenter = "_p-9";
export var alignSelfFlexStart = "_p-a";
export var alignSelfFlexEnd = "_p-b";
export var alignSelfStretch = "_p-c";
export var alignSelfBaseline = "_p-d";
export var justifyCenter = "_p-e";
export var justifyFlexStart = "_p-f";
export var justifyFlexEnd = "_p-g";
export var justifySpaceBetween = "_p-h";
export var justifySpaceAround = "_p-i";
export var justifySpaceEvenly = "_p-j";
export var wrapWrap = "_p-k";
export var wrapNowrap = "_p-l";
export var wrapWrapReverse = "_p-m";
export default ___CSS_LOADER_EXPORT___;
